import Home from ".";
import authRoles from "../../utils/auth.roles";
const AccountsRoutes = {
  auth: authRoles.user,
  kyc: false,
  // add this to the route which dont require mfa to be complated
  mfaNotRequired: true, 
  routes: [
    {
      path: "/accounts",
      component: Home,
      exact: true,
    },
  ],
};
export default AccountsRoutes;
